import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../AuthContext'
import { useState, useEffect } from 'react'
import './Nav.css'

export default function Nav() {
  const { usuario, logout } = useAuth()
  const navigate = useNavigate()
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const handleLogout = () => {
    logout()
    navigate('/')
    setMenuOpen(false)
  }

  return (
    <nav className={`nav ${scrolled ? 'scrolled' : ''}`}>
      <Link to="/" className="nav-logo">El Rincón de la Escandella</Link>

      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
        <li><Link to="/" onClick={() => setMenuOpen(false)}>Inicio</Link></li>
        <li><Link to="/carta" onClick={() => setMenuOpen(false)}>Menú del día</Link></li>
        <li><a href="/#galeria" onClick={() => setMenuOpen(false)}>Galería</a></li>
        <li><Link to="/alergenos" onClick={() => setMenuOpen(false)}>Alérgenos</Link></li>
        <li><Link to="/reservas" onClick={() => setMenuOpen(false)}>Reservar</Link></li>
        {usuario?.es_admin && (
          <>
            <li><Link to="/admin" onClick={() => setMenuOpen(false)}>Admin</Link></li>
            <li><button className="nav-logout" onClick={handleLogout}>Salir</button></li>
          </>
        )}
      </ul>

      <button className="nav-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        <span></span><span></span><span></span>
      </button>
    </nav>
  )
}
